class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.closeDelay = 120;
    this.closeTimer = null;
    this.hoverMedia = window.matchMedia('(min-width: 990px)');

    if (this.mainDetailsToggle.classList.contains('mega-menu')) {
      this.bindMegaMenuHover();
    }
  }

  bindMegaMenuHover() {
    this.addEventListener('mouseenter', this.onMegaMenuMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMegaMenuMouseLeave.bind(this));

    this.summary.addEventListener(
      'click',
      (event) => {
        if (!this.hoverMedia.matches) return;
        if (event.target.closest('a[href]')) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  }

  onMegaMenuMouseEnter() {
    if (!this.hoverMedia.matches) return;

    clearTimeout(this.closeTimer);

    document.querySelectorAll('header-menu .mega-menu[open]').forEach((details) => {
      if (details === this.mainDetailsToggle) return;
      details.removeAttribute('open');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });

    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', 'true');
    }
  }

  onMegaMenuMouseLeave() {
    if (!this.hoverMedia.matches) return;

    this.closeTimer = setTimeout(() => {
      this.close();
    }, this.closeDelay);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
